module.exports = __webpack_public_path__ + "media/images/flags/64/Indonesia-68dd02bfd34e67b937ed001ca0711f29.png";